var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87305 15.6605L13.873 11.5137L12.473 10.0623L10.873 11.721V7.36695H8.87305V11.721L7.27305 10.0623L5.87305 11.5137L9.87305 15.6605ZM2.87305 5.29356V16.6972H16.873V5.29356H2.87305ZM2.87305 18.7705C2.32305 18.7705 1.85221 18.5675 1.46055 18.1615C1.06888 17.7555 0.873047 17.2673 0.873047 16.6972V3.76444C0.873047 3.52255 0.910547 3.28929 0.985547 3.06468C1.06055 2.84006 1.17305 2.63272 1.32305 2.44266L2.57305 0.861709C2.75638 0.619814 2.98555 0.434073 3.26055 0.304487C3.53555 0.174901 3.82305 0.110107 4.12305 0.110107H15.623C15.923 0.110107 16.2105 0.174901 16.4855 0.304487C16.7605 0.434073 16.9897 0.619814 17.173 0.861709L18.423 2.44266C18.573 2.63272 18.6855 2.84006 18.7605 3.06468C18.8355 3.28929 18.873 3.52255 18.873 3.76444V16.6972C18.873 17.2673 18.6772 17.7555 18.2855 18.1615C17.8939 18.5675 17.423 18.7705 16.873 18.7705H2.87305ZM3.27305 3.22018H16.473L15.623 2.18349H4.12305L3.27305 3.22018Z",
    fill: "#28292C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchived);
export default __webpack_public_path__ + "static/media/archived.cfecb66d385709dfb969ad43702aa1cd.svg";
export { ForwardRef as ReactComponent };